import React, { ReactElement } from "react";

import Button from "../../button";
import Icon from "../../icon";
import { ChatSourcesProps } from "./ChatSources.types";

export const ChatSources = ({
  actionLink,
  title,
}: ChatSourcesProps): ReactElement => (
  <div className="spark-mar-t-1">
    <span className="spark-mar-b-1 spark-block">
      <strong>Sources</strong>
    </span>
    <Button
      style={{
        border: "1px solid #e6e6e6",
        borderRadius: 8,
        padding: 10,
        textTransform: "none",
      }}
      textOnly
    >
      <>
        <a href={actionLink} target={"_blank"} rel="noreferrer">
          {title?.substring(0, 40)}
        </a>
        <Icon
          className="spark-mar-l-.5"
          style={{ marginTop: -10, marginBottom: -6 }}
          name="out"
        />
      </>
    </Button>
  </div>
);
